var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDomain } from 'core/domain/common';
var LoginUser = /** @class */ (function (_super) {
    __extends(LoginUser, _super);
    function LoginUser(_uid, _emailVerified, _providerId, _displayName, _email, _avatarURL) {
        if (_providerId === void 0) { _providerId = ''; }
        if (_displayName === void 0) { _displayName = ''; }
        if (_email === void 0) { _email = ''; }
        if (_avatarURL === void 0) { _avatarURL = ''; }
        var _this = _super.call(this) || this;
        _this._uid = _uid;
        _this._emailVerified = _emailVerified;
        _this._providerId = _providerId;
        _this._displayName = _displayName;
        _this._email = _email;
        _this._avatarURL = _avatarURL;
        return _this;
    }
    Object.defineProperty(LoginUser.prototype, "uid", {
        /**
         * User identifier
         *
         * @type {string}
         * @memberof LoginUser
         */
        get: function () {
            return this._uid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginUser.prototype, "emailVerified", {
        /**
         * If user's email is verifide {true} or not {false}
         *
         * @readonly
         * @type {boolean}
         * @memberof LoginUser
         */
        get: function () {
            return this._emailVerified;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginUser.prototype, "providerId", {
        get: function () {
            return this._providerId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginUser.prototype, "displayName", {
        // public get location (): string {
        //   return this._location
        // }
        get: function () {
            return this._displayName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginUser.prototype, "email", {
        get: function () {
            return this.email;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginUser.prototype, "avatarURL", {
        get: function () {
            return this._avatarURL;
        },
        enumerable: true,
        configurable: true
    });
    return LoginUser;
}(BaseDomain));
export { LoginUser };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/authorize/loginUser.ts
// module id = 645
// module chunks = 50